import React from "react";
import FAQItem from "../components/home/FAQItem";
import Container from "../components/common/Container";
import StaticHeaderImage from "../assets/img/common/static-pages-header.png";
import ExternalLink from "../components/common/ExternalLink";
import MetaTags from "../components/common/MetaTags";
const Terms = () => {
  return (
    <div className="w-full flex flex-col items-center pt-32">
      <MetaTags
        title="Terms of service"
        description={`NFT- Fundraising By FunDeSci An innovative approach for decentralized crowdfunding of scientific projects`}
        link="/terms-of-service"
      />
      <section
        style={{
          backgroundImage: `url(${StaticHeaderImage})`,
        }}
        className="w-full flex flex-col justify-center items-center h-48 bg-[rgba(30,21,65,0.80)] bg-no-repeat bg-cover bg-blend-multiply bg-center"
      >
        <h1 className="text-4xl sm:text-[45px] text-center abel-font font-bold text-white tracking-wider">
          Terms of service
        </h1>
      </section>
      <Container>
        <div className="w-full flex flex-col mt-20 pb-10 terms-wrapper poppins-font">
          <h2>1. Welcome to FunDeSci!</h2>
          <p>
            Fundesci LLC (together with its and their parents, subsidiaries,
            affiliates, agents, representatives, consultants, employees,
            officers, and directors—collectively, "Fundesci," "we," or "us")
            provides this website (the "Site") and the services (together with
            the Site, the "Services") subject to your compliance with these
            legally binding rules (the "Terms"). By using the Site, you also
            agree to abide by our Community Guidelines and Rules for Beginning
            Projects, as well as our Privacy Policy and Cookie Policy.
            <br />
            <br />
            From time to time, we may update these conditions. If we do, we will
            post a notice on the Site or send you an email to let you know about
            any significant changes. Any significant modifications will be
            communicated to EU-based creators at least 15 days in advance of
            their implementation. We will always let you know when the new terms
            take effect, and they will never be retroactive. By continuing to
            use Fundesci after any modifications, you agree to be bound by the
            revised terms.
          </p>

          <h2>2. About Creating an Account</h2>
          <p>
            You don't need an account to look around Fundesci. However, signing
            up, a unique username, and password are required for access to
            certain Fundesci features. You must provide us with true and
            comprehensive details while doing so. Don't choose names that may be
            seen as an infringement of someone else's rights or an impersonation
            of someone else. Your account might be terminated if you violate
            these terms.
            <br />
            <br />
            It is your exclusive responsibility to keep your passwords and
            cryptocurrency wallet secure. You must notify{" "}
            <ExternalLink href="mailto:support@fundesci.com">
              support@fundesci.com
            </ExternalLink>{" "}
            immediately if you discover unauthorized account usage.
            <br />
            <br />
            If you want to create an account, you must be at least 18 years old,
            or the legal age in your jurisdiction to enter into a legally
            binding agreement. We reserve the right to request proof of age from
            you.
          </p>

          <h2>3. Things You Definitely Shouldn’t Do</h2>
          <p>
            <br />
            <strong>Be lawful.</strong> Don't violate anyone's rights, the law,
            or your legal obligations.
            <br />
            <br />
            <strong>Never deceive.</strong> Post truthful information. Don't
            cheat.
            <br />
            <br />
            <strong>Avoid selling illegal things.</strong> Don't give awards
            that violate Fundesci's policies, regulations, or laws.
            <br />
            <br />
            <strong>Victimize nobody.</strong> Do not threaten, abuse, harass,
            defame, libel, tort, vulgar, profane, or invade privacy.
            <br />
            <br />
            <strong>No spam.</strong> Send no junk mail, spam, or chain letters.
            Avoid mailing lists, listservs, auto-responders, and spam on the
            Site.
            <br />
            <br />
            <strong> Don’t damage computers.</strong> Distribute no software
            viruses or other code, videos, or programs that disrupt the Site's
            software, hardware, or equipment, whether Fundesci's or not.
            <br />
            <br />
            <strong>Use personal data responsibly.</strong> If your Fundesci
            initiative succeeds, you may obtain other users' names, email
            addresses, and postal addresses. Don't misuse this information—it's
            for Fundesci projects only.
            <br />
            <ul>
              <li>Avoid disrupting the Services.</li>
              <li>Avoid circumventing Service security mechanisms.</li>
              <li>
                Don't damage or hack Fundesci or other systems, data, passwords,
                or other information.
              </li>

              <li>
                Avoid overloading our infrastructure or third-party services.
                (We decide reasonableness.)
              </li>
              <li>
                Do not "crawl" or "spider" the Site with any program or device,
                manual or automated.
              </li>
              <li>
                Don't disassemble Fundesci to get its source code, concepts, or
                algorithms.
              </li>
            </ul>
          </p>

          <h2>4. How Projects Work</h2>
          <p>
            Fundesci supports creative ventures. Creators who post projects on
            Fundesci invite others to contract with them. Backers sign the
            contract with the creator.
            <br />
            <br />
            This contract is between creators and their backers—Fundesci is not
            involved. Agreement terms:
            <br />
            <br />
            Successfully financed projects must be completed and all rewards
            fulfilled. The developer has fulfilled their supporters'
            obligations.
            <br />
            <br />
            Creators owe their supporters hard work, honest communication, and
            devotion to the project. When they fund a project, backers are
            helping to build something new, not purchasing it. Changes or delays
            may occur, and the author may not complete the project on time.
            <br />
            <br />
            A creator has violated this agreement if they cannot finish their
            project and provide prizes. They must try to find a better approach
            to finish the project for supporters. Only if:
            <br />
            <br />
            They submit an update detailing what work has been done, how
            donations were utilized, and what is preventing them from completing
            the project.
            <br />
            <br />
            They work hard and honestly to finish the assignment on schedule.
            <br />
            <br />
            They can prove they handled cash wisely and worked hard to finish
            the job on time.
            <br />
            <br />
            They've been honest and haven't made any material misrepresentations
            to backers, and they offer to return any remaining funds to backers
            who haven't received their reward (in proportion to the amounts
            pledged) or explain how those funds will be used to finish the
            project.
            <br />
            <br />
            Creators are entirely accountable for project commitments. Backers
            may sue if they fail to meet this obligation. Fundesci may act on
            campaign money during a dispute.
          </p>
          <h2>5. How Funding Works</h2>
          <p>
            FunDeSci is a platform that allows organizations to award grants and
            raise funds via crowdsourcing and auctions for scientific research
            initiatives. Here's how our platform handles funding:
            <br />
            <br />
            Create a project or grant: Researchers or organizations may use our
            platform to establish a project or grant by giving information about
            their scientific research aims, methodologies, and projected
            results. They may choose the finest fundraising approach for their
            requirements, such as auctions or crowdsourcing.
            <br />
            <br />
            Fundraising: Once a project is announced on our site, investors and
            donors may begin giving cryptocurrencies to support it. The
            supported amount will be transferred to researchers' wallets via
            smart contracts, and the contributor will get a non-fungible token
            (NFT).
            <br />
            <br />
            If a project exceeds its financial objective before the fundraising
            period expires, the finance will be transferred to the project or
            grant owner and project labeled as successfully funded. If a project
            does not reach its financial objective, the profits from the sale of
            NFTs will still be used to enhance scientific research. However, the
            initiative will not obtain the entire financing objective that they
            had hoped for.
            <br />
            <br />
            Funding allocation: When a project is awarded, the owner receives
            the cryptocurrency and uses them to further their scientific study.
            They will also offer contributors with frequent updates on the
            project's development.
            <br />
            <br />
            Fees: We charge a 2.5% platform fee on all monies generated by a
            project or grant. Furthermore, contributors may be charged
            blockchain transaction fees depending on current network congestion,
            which may change at any moment.
            <br />
            <br />
            We aspire to create a transparent, safe, and efficient platform for
            scientific research financing. Please email us at{" "}
            <ExternalLink href="mailto:support@fundesci.com">
              support@fundesci.com
            </ExternalLink>{" "}
            if you have any questions or issues about how fundraising works on
            FunDeSci.
          </p>
          <h2>6. Stuff We Don’t Do and Aren’t Responsible For</h2>
          <p>
            Fundesci isn't responsible for Service-related damages. We don't get
            involved in Service-related issues between users or other parties.
            We don't monitor project performance or endorse user material on the
            Site. When you use the Services, you release Fundesci from any
            claims, damages, and demands—known or unknown, suspected or
            unsuspected, revealed or undisclosed—arising from or connected to
            such disputes and the Services. You are responsible for all Services
            content. You're liable for any damages.
          </p>

          <h2>7. Our Fees</h2>
          <p>
            Signing up with Fundesci doesn't cost anything. We charge a 2.5% fee
            plus the cost of blockchain transactions for each project you start
            that is successfully funded. The costs associated with blockchains
            will change depending on factors such as network congestion.
            <br />
            <br />
            We will not charge your card until you have had the opportunity to
            examine and approve the associated charges. If there is ever a
            change in our prices, we will post a notice on our site. Some of the
            money raised from supporters is used to make transactions via the
            blockchain. Fundesci cannot guarantee the efficacy of any specific
            blockchain due to differences in protocol.
            <br />
            <br />
            Any applicable taxes or fees accrued as a result of your use of
            Fundesci are your financial responsibility.
          </p>

          <h2>8. Your Intellectual Property</h2>
          <p>
            Fundesci does not own your Content. Our Services need specific
            licenses from you. These conditions apply to project submissions and
            launches: Your content is acceptable. You give us and our agents the
            worldwide, non-exclusive, permanent, irrevocable, royalty-free,
            sublicensable, transferable right to use, exercise, market, and
            exploit your Content's copyright, publicity, trademark, and database
            rights. This Content promotes initiatives and our community on the
            internet. We assess various aspects before promoting a project on
            the homepage or granting it a Project We Love badge. This includes,
            but is not limited to, a crisp project image with no logos, badges,
            or text on top, a clear and detailed description that includes a
            thorough plan for completing your project, captivating images or
            videos, an excited community, what we think different users will be
            interested in, and of course, a lot of creativity. We also edit the
            webpage to promote exceptional Fundesci initiatives. The top
            projects on the homepage are usually Projects We Love, based on
            creative innovation, honesty, and alignment with Fundesci's mission
            and charter, but we also use algorithms to surface popular projects,
            projects your friends have backed and launched, and projects
            recommended just for you. We may also promote projects that are
            gaining momentum according to their creator's advertising, a user's
            search terms, browsing history, project backings, and other
            activities, and cookies we have gathered throughout their visits to
            our website.
            <br />
            <br />
            We can modify and translate Content. You authorize us to edit,
            reformat, excerpt, remove, or translate your Content.
            <br />
            <br />
            You won't submit copyrighted material without authorization. Your
            Content will not contain third-party copyrighted or proprietary
            material unless you have permission from the rightful owner or are
            legally entitled to post it (and grant Fundesci all the license
            rights outlined here).
            <br />
            <br />
            Content royalties and licensing are your responsibility. You shall
            pay any royalties and other amounts due for your Content or
            Fundesci's hosting of such Content.
            <br />
            <br />
            You agree that using your Content won't violate anyone's rights or
            copyrights. You agree that Fundesci or its users' use of your
            submission will not violate any third party's rights, including
            privacy, publicity, copyrights, contract, or other intellectual
            property or proprietary rights. Your posts are yours. The owner of
            Content uploaded or communicated to the Site is responsible for it.
            <br />
            <br />
            Content errors are not our responsibility. Fundesci is not
            responsible for Content mistakes.
          </p>
          <h2>9. Fundesci’s Intellectual Property</h2>
          <p>
            Copyrights, trademarks, service marks, patents, trade secrets, and
            other rights and laws protect Fundesci's Services. Copyright and
            other legal notices, information, and limitations may be included in
            material that you access via the Site, and you agree to abide by
            them. The Service may not be modified, translated, or used to
            generate any derivative works without our express written
            permission.
            <br />
            <br />
            If you want to copy anything from Fundesci's Services and use it for
            your own purposes, you have our permission to do so. Both
            proprietary materials created by Fundesci and user-created content
            on the Site are included in the scope of this agreement. (This is a
            global, non-exclusive license that cannot be transferred or
            sublicensed in any way.) You require express permission from
            Fundesci or the applicable copyright holder to use, reproduce, edit,
            distribute, or store any of this information commercially. For the
            purposes of this agreement, "commercial purpose" includes any use,
            sale, licensing, rental, or other commercial exploitation of the
            material.
          </p>

          <h2>10. Deleting Your Account</h2>
          <p>
            You can remove your account at any moment, but it will not delete
            anything you've shared before.
            <br />
            <br />
            As an applicant or an organization, through the Profile Settings,
            you may delete your account at any moment. In some circumstances, we
            may be required by law or feel it is important to keep records for
            as long as necessary. Even if you close your account, this agreement
            will still be in effect. This includes our rights to any information
            you've already put on the Site. (If you have already published
            content, such as a project, and then delete your account, the
            content will remain on the Site.) Also your transactions and NFTs on
            blockchain platforms will be permanently recorded. If you have any
            questions or would like to have your project page removed (not
            always possible), please email{" "}
            <ExternalLink href="mailto:support@fundesci.com">
              support@fundesci.com
            </ExternalLink>{" "}
          </p>

          <h2>11. Warranty Disclaimer</h2>
          <p>
            We work hard to offer you satisfactory services; however, we are
            unable to assure that everything will work flawlessly all the time.
            <br />
            <br />
            Our services are used at your own risk. They are given to you "as
            is" and "as available," with no written or implied Warranty of any
            kind.
          </p>

          <h2>12. Indemnification</h2>
          <p>
            If you act on anything that gets us to file a lawsuit against us or
            break an obligation you made in this agreement, you agree to defend,
            indemnify, and keep us harmless from any obligations, assertions,
            and expenditures (including reasonable attorneys' fees and other
            legal expenses) that come from or are related to your use or misuse
            of FunDeSci. We reserve the right to defend and take charge of any
            matter that would otherwise be covered by this compensation clause.
            If we do this, you agree to work with us and help us make any
            arguments. As part of this, by agreeing to these Terms of Use, you
            agree that FunDeSci can serve you with legal papers for any lawsuit
            that could be made against the site for any reason.
          </p>

          <h2>13. Limitation of Liability</h2>
          <p>
            FunDeSci and its affiliates shall not be held liable for any
            indirect, incidental, punitive, consequential, special, or exemplary
            damages of any kind, including but not limited to damages resulting
            from the user's access to, use of, or inability to access or use the
            Services. This includes any lost profits, data loss, or cost of
            procurement or substitute goods or services. Additionally, FunDeSci
            and its affiliates shall not be held responsible for the conduct or
            content of any third party on the Site. This limitation of liability
            applies to the fullest extent permitted by law.
          </p>
          <h2>14. Dispute Resolution and Governing Law</h2>
          <p>
            Due to the fact that we are based in Dubai, UAE law stipulates that
            any conflicts involving us must be resolved in UAE.
          </p>
        </div>{" "}
      </Container>
    </div>
  );
};

export default Terms;
